import {
  SET_DASHBOARD_SEGMENTS,
  SET_SELECTED_SEGMENT,
  SET_CUSTOMER_SEGMENTS,
  RESET_SELECTED_SEGMENT,
  RESET_AUDIENCE_REC_STATE,
} from "../types";

const initialState = {
  dashboardSegments: [], //for dashboard and campaigns page-min customer count=500
  customerSegments: [], //for customer list and campaign audience page-min customer count=100
  selectedSegment: {}, // selected segment throughout the campaigns and customer insights journey
};

const audienceRecommendationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DASHBOARD_SEGMENTS:
      return {
        ...state,
        dashboardSegments: action.payload,
      };
    case SET_CUSTOMER_SEGMENTS:
      return {
        ...state,
        customerSegments: action.payload,
      };
    case SET_SELECTED_SEGMENT:
      return {
        ...state,
        selectedSegment: action.payload,
      };
    case RESET_SELECTED_SEGMENT:
      return {
        ...state,
        selectedSegment: {},
      };
    case RESET_AUDIENCE_REC_STATE:
      return initialState;
    default:
      return state;
  }
};
export default audienceRecommendationReducer;
